<template>
  <div>
    <!-- 日历库存 -->
    <el-page-header @back="goBack" :content="'日历库存'" />
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @etidSubmit="etidSubmit"
      @refreshBtn="refreshBtn"
    ></zx-table>
    <ele-form-dialog
      v-model="formData"
      :formDesc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      labelPosition="left"
      :form-attrs="{ size: 'small' }"
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }"
      v-dialogdrag
      :visible.sync="dialogFormVisible"
      @request-success="handleSuccess"
      :title="table.title"
    />
  </div>
</template>

<script>
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      rules: {},
      formDesc: {
        date: {
          field: "date",
          label: "开始时间",
          type: "daterange",
          attrs: {
            // rangeSeparator:new Date(),
            valueFormat: "yyyy-MM-dd-hh:mm:ss",
            pickerOptions: {
              disabledDate(time) {
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24);
                return time.getTime() <= start;
              },
              shortcuts: [
                {
                  text: "今天",
                  onClick(picker) {
                    const start = new Date();
                    const end = new Date();
                    // end.setTime(start.getTime() + 3600 * 1000 * 24 );
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "明天",
                  onClick(picker) {
                    const start = new Date();
                    const end = new Date();
                    end.setTime(start.getTime() + 3600 * 1000 * 24);
                    start.setTime(start.getTime() + 3600 * 1000 * 24);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "未来一周",
                  onClick(picker) {
                    const start = new Date();
                    const end = new Date();
                    end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "未来一个月",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "未来三个月",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
                    picker.$emit("pick", [start, end]);
                  }
                }
              ]
            }
          }
        },
        sku: {
          required: true,
          type: "number",
          label: "库存",
          layout: 12,
          attrs: {
            min: 0,
            controls: false
          }
        }
      },
      formData: {},
      dialogFormVisible: false,
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        // sizes, prev, pager, next, jumper, ->, total, slot
        // "layout":"prev, pager, next",
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "日历库存",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: true,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "group_name",
            label: "用户组名称",
            type: "input",
            required: true,
            hide: true
          },
          {
            prop: "order_num",
            label: "排序",
            type: "number",
            layout: 12,
            hide: true
          }
        ],
        btnNavLeft: [
          {
            text: "添加",
            size: "mini",
            type: "success",
            click: () => {
              this.dialogFormVisible = true;
            }
          }
        ]
      },
      tableData: [],
      ticket_id: this.$route.query.ticket_id
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  margin-bottom: 10px;
  .body-item {
    .item-info {
      height: 250px;
    }
    &:nth-child(odd) {
      .item-info {
        background: #99a9bf;
      }
    }
    &:nth-child(even) {
      .item-info {
        background: #e5e9f2;
      }
    }
  }
}
</style>
